import type { RouterAppContext } from "@/utils/custom-types";
import { createFileRoute } from "@tanstack/react-router";
import { ChatView } from "@/components/views";

export const Route = createFileRoute("/$workspaceId/chats/$channelId")({
	component: () => {
		const { workspaceId, channelId } = Route.useParams();
		const { session, currentWorkspace } =
			Route.useRouteContext() as RouterAppContext;

		console.log("laoding chat view");
		
		return (
			<ChatView
				workspaceId={workspaceId}
				channelId={channelId}
				session={session}
				currentWorkspace={currentWorkspace}
			/>
		);
	},
});
